import api from '../services/api';
import { $Q, $Qll } from '../utils/querySelector';
import { redirect } from '../utils/redirect';
import { RenderElements } from '../utils/renderElement';
import { toggleDataActive, dataToggle } from '../utils/toggleDataset';
import { barProgress } from './bar-progress';
import { checkValidation } from './checkout-validation';
import { sliderUpsell } from './slider-swiper';

barProgress($Q('#progress-bar-data'));
sliderUpsell();

/**
 * Cart functionalities
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */

class Cart {
  constructor() {
    this.cartItems = $Q('#js-cart-items');
    this.API = api;
    this.cartItems && this._init();
    this.initCountAtHeader();
    this.renderElements = new RenderElements();
    $Q('body') && this.observeBundle();
  }

  /**
   * Init cart functionalities
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _init() {
    this._addEvents();
  }

  /**
   * Add events to the cart
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _addEvents() {
    $Qll('.js-cart-item', $Q('#js-cart-items')).forEach((item) => {
      this.variantId = item.dataset.variantId;
      this.accessory = item.dataset.accessory;
      this.engraving = item.dataset.engraving;
      this.quantity = item.dataset.quantity;
      this.sectionId = item.dataset.sectionId;
      this.engravingPackId = item.dataset.engravingPackId;
      this.engravingOtp = item.dataset.engravingOtp;
      this.set = item.dataset.set;
      this.quantitySection =
        $Q('quantity-dropdown', item) !== null
          ? $Q('quantity-dropdown', item)
          : $Q('quantity-input', item);

      this.quantitySection?.addEventListener(
        'change',
        this.onChange.bind(this, this.variantId, this.sectionId, this.set)
      );

      $Q('#js-cart-remove-item', item)?.addEventListener(
        'click',
        this.removeItemCart.bind(
          this,
          this.variantId,
          this.sectionId,
          this.set,
          this.engravingOtp,
          this.engravingPackId,
          this.engraving,
          this.quantity,
          this.accessory
        )
      );
    });

    sliderUpsell();
    barProgress($Q('#progress-bar-data'));
    this.callAddToCartForUpsell();
    checkValidation();
    toggleDataActive('.js-cart-close', '#shopify-section-side-cart', {
      overlay: true,
    });
  }

  /**
   * Callback event change of the qty cart
   * @param {String} variant - Product variant id
   * @param {String} sectionId - Section id
   * @param {Object} e - Change event
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  onChange(variant, sectionId, line, e) {
    this._updateCart(e.target.value, variant, sectionId, line);
  }

  /**
   * Update cart with api cart and get sections updated to do render and update front.
   * Init events again
   * @param {Number} variant - Variant product
   * @param {Number} quantity - Product quantity
   * @param {String} line - Product line
   * @param {String} sections - Sections ids to get section
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */

  async _updateCart(quantity, id, sections, line) {
    try {
      //Enable loader
      this._enableLoading(line);

      const response = await this.API.updateCart({
        line: line,
        quantity,
        sections,
      });

      //Update cart for line
      for (const key in response.sections) {
        if (Object.hasOwnProperty.call(response.sections, key)) {
          $Q(`#shopify-section-${key}`).innerHTML = this.getSectionInnerHTML(
            response.sections[key],
            key
          );
          this._addEvents();
          this.initCountAtHeader();
        }
      }

      //Disable loader
      this._disableLoading();
    } catch (error) {
      this._disableLoading();
      console.error(`Error: ${error}`);
    }
  }

  /**
   * Parse String to HTML for got section with the Shopify API and ready to render
   * @param {String} html - String html to become to html
   * @param {String} selector - Section id to get only node section of the HTML became
   * @returns {Node} - Node (section) to update in front
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(`#shopify-section-${selector}`).innerHTML;
  }

  /**
   * Enable loader in each item cart when add, minus or remove items cart
   * @param {String} variantId - Product variant id to get items
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _enableLoading(variantId) {
    $Q('#js-cart-items').classList.add('cart__items--disabled');

    $Qll(`[data-set="${variantId}"] .loading-overlay`).forEach((line) => {
      if (
        line.classList.contains('hidden') &&
        !line.nextElementSibling.classList.contains('loading')
      ) {
        line.classList.remove('hidden');
        line.nextElementSibling.classList.add('loading');
      }
    });
  }

  /**
   * Remove css class disable (disable mode disable).
   * The items cart are restore in the section rendering
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _disableLoading() {
    $Q('#js-cart-items')?.classList?.remove('cart__items--disabled');
  }

  /**
   * Listen when the form is submit, evaluating the form if exist product engraving
   * and add accesories item
   * @author Michael Ballen
   * @see addProducts(e)
   */

  addToCart(upsellElements = undefined) {
    // Filtra elementos que no tengan la bandera data-flagged="true"
    const addForms =
      upsellElements !== undefined
        ? upsellElements
        : Array.from($Qll('.add-cart-form')).filter(
          (form) => !form.hasAttribute('data-flagged')
        );

    const sectionEngraving = document.querySelector('.product-engraving');
    const accesorieId = document.querySelector('.accesories_checkbox')?.dataset
      .accesoryId;
    const idProductOtp = document.querySelector(
      '.variants input[name="id"]'
    )?.value;

    const submitHandler = async (e) => {
      e.preventDefault();

      const cartBtn = $Q('.btn-cart-js', e.target) || $Q('.btn-sticky-cart-js', e.target);
      const contentButton = this.addSpinner(cartBtn);

      if (sectionEngraving?.dataset.variant_engraving) {
        const dataEngraving = JSON.parse(localStorage.getItem('engraving'));
        this.addToCartItems(dataEngraving);
      } else {
        console.log('e', e)
        const response = await this._addProducts(e, accesorieId);
        accesorieId && this.addAccesories(accesorieId, e);
        this._updateSidecart(response);

        if (e.target.dataset.typeForm !== 'upsell') {
          console.log('this is the activation of the toggle');
          dataToggle($Q('#shopify-section-side-cart'), true);
        }
        this.initCountAtHeader();
      }

      this.removeSpinner(cartBtn, contentButton);
    };

    // Agregar event listeners y marcar con data-flagged="true"
    addForms.forEach((productForm) => {
      if (productForm != null) {
        productForm.removeEventListener('submit', submitHandler);
        productForm.addEventListener('submit', submitHandler);
        productForm.setAttribute('data-flagged', 'true');
      }
    });
  }

  callAddToCartForUpsell = () => {
    const addForm = $Qll('.add-cart-form[data-form="upsell"]');

    if (addForm) {
      this.addToCart(addForm);
    }
  };

  addSpinner = (element) => {
    if (!element) return;

    const content = [...element.childNodes];

    element.disabled = true;
    element.innerHTML = "<div class='spinner-btn'></div>";

    return content;
  };

  removeSpinner = (element, content) => {
    if (!element || !$Q('.spinner-btn', element)) return;

    $Q('.spinner-btn', element).remove();

    element.append(...content);
    if (element.disabled) element.disabled = false;
  };

  /**
   * Open Side Cart when the cart request is OK
   * @param {object} target
   */
  openSingleCart = (target) => {
    if (target.dataset.typeForm !== 'upsell') {
      dataToggle($Q('#shopify-section-side-cart'), true, true);
    }
  };

  _updateSidecart(response) {
    //Update sidecart for line
    for (const key in response.sections) {
      if (Object.hasOwnProperty.call(response.sections, key)) {
        $Q(`#shopify-section-${key}`).innerHTML = this.getSectionInnerHTML(
          response.sections[key],
          key
        );
        this._addEvents();
        this.initCountAtHeader();
      }
    }
  }

  showCartNotification(productTitle) {
    const notificationContainer = $Q('.cart-notification');
    const stickyNotificationContainer = $Q('.cart-notification__container');

    if (notificationContainer != null) {
      this.updateCartNotification(notificationContainer, productTitle);
    }
    if (stickyNotificationContainer) {
      if (stickyNotificationContainer.innerHTML != '') {
        this.updateCartNotification(stickyNotificationContainer, productTitle);
      } else {
        this.showStickyCartNotification(
          stickyNotificationContainer,
          notificationContainer
        );
      }

      this.closeCartNotification(
        notificationContainer,
        stickyNotificationContainer
      );
    }
  }

  updateCartNotification(container, productTitle) {
    const nameProduct = $Q('#notification-product-name', container);
    nameProduct.innerText = `${productTitle}`;
    container.classList.remove('hidden');
  }

  closeCartNotification(container, otherContainer) {
    const closeIcon = $Q('.cart-notification__container--close', container);

    closeIcon.addEventListener('click', () => {
      container.classList.add('hidden');

      if (otherContainer != null) {
        otherContainer.classList.add('hidden');
      }
    });
  }

  showStickyCartNotification(
    stickyNotificationContainer,
    notificationContainer
  ) {
    const closeContainer = $Q('.cart-notification__container--close');

    if (stickyNotificationContainer != null && notificationContainer != null) {
      stickyNotificationContainer.innerHTML = notificationContainer.innerHTML;
      this.closeCartNotification(
        stickyNotificationContainer,
        notificationContainer
      );
    }
  }

  /**
   * Add selected variant in cart
   * @param {Event} event submit event from add to cart form
   * @author Michael Ballen
   */
  async _addProducts(event, accessoryId = null) {
    let id;
    const CART_SECTION = 'side-cart';

    const properties = {};

    for (const input of event.target) {
      if (input.name === 'id') {
        id = input.value;
      } else if (input.name.includes('properties[')) {
        const name = input.name.replace('properties[', '').slice(0, -1);
        properties[name] = input.value;
      }
    }

    const cartNote = $Q('#preorder-note', event.target);
    if (cartNote != null) {
      const customNote = cartNote.value;
      properties[Note] = 'Preorder';
      const cartParams = {
        items: [
          {
            id: id,
            quantity: 1,
            properties,
          },
        ],
        sections: CART_SECTION,
      };

      return await api.addToCart(cartParams);
    } else {
      const cartParams = {
        items: [
          {
            id: id,
            quantity: 1,
            properties,
          },
        ],
        sections: CART_SECTION,
      };

      if (accessoryId) {
        cartParams.items[0].properties._accessory = `accesory-${id}-${accessoryId}-item`;
      }

      return await api.addToCart(cartParams);
    }
  }

  /**
   * Add accesories to the cart and if exist id  productOtp also is added to the cart
   * @param {Event} addAccesories items  to add  accesories to cart
   * @author Miguel Camacho
   */

  async addAccesories(accessoryId = null, e) {
    let id;
    const CART_SECTION = 'side-cart';

    for (const input of e.target) {
      if (input.name === 'id') {
        id = input.value;
      }
    }

    const cartParams = {
      items: [
        {
          id: accessoryId,
          quantity: 1,
          properties: {
            _accessory: `accesory-${id}-${accessoryId}-item`,
          },
        },
      ],
      sections: CART_SECTION,
    };
    await this.addToCartItems(cartParams);
  }

  /**
   * Add selected variant in cart
   * @param {Event} dataUtil items  to add  engraving
   * @author Miguel Camacho
   */

  async addToCartItems(dataUtil) {
    const response = await this._addProductsEngraving(dataUtil);

    const productTitle = response.items[1]?.product_title;
    productTitle && this.showCartNotification(productTitle);

    this.initCountAtHeader();
  }

  /**
   * Add selected variant in cart
   * @param {Event} items items  to add  engraving
   * @author Miguel Camacho
   */
  async _addProductsEngraving(items) {
    return await api.addToCart(items);
  }

  /**
   * Redirect
   */
  redirectToCart() {
    redirect(window.routes.cart_url);
  }

  /**
   * loading multi-lines when deleted many products
   * @author Miguel Camacho <miguel.camacho@gradiweb.com>
   */

  async snipetLoader(elements = []) {
    for (let i = 0; i < elements.length; i++) {
      this._enableLoading(elements[i].dataset.set);
    }
  }

  /**
   * Send quantity 0 to the item for remove of the cart
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  async removeItemCart(
    id,
    sections,
    line,
    engravingOtp,
    engravingPackId,
    engraving,
    quantity,
    accessory
  ) {
    try {
      //Enable loader
      if (engraving) {
        let elementsLoader = document.querySelectorAll(
          `[data-engraving-pack-id=${engravingPackId}]`
        );
        elementsLoader &&
          (await this.snipetLoader(elementsLoader).then(async (res) => {
            await this.removeData(line, sections).then(async (res) => {
              let elements =
                document.querySelectorAll(
                  `[data-engraving-pack-id=${engravingPackId}]`
                ) || [];
              for (let i = 0; i < elements.length; i++) {
                await this.snipetLoader(elements).then(async () => {
                  await this.removeData(
                    elements[i].dataset.set,
                    elements[i].dataset.sectionId
                  ).then(async (res) => {
                    if (elements.length > 1) {
                      await this.removeData(
                        elements[i].dataset.set,
                        elements[i].dataset.sectionId
                      );
                    }
                  });
                });
                break;
              }
            });
          }));
      } else if (accessory) {
        let elementsAccesory = document.querySelectorAll(
          `[data-accessory=${accessory}]`
        );
        elementsAccesory &&
          (await this.snipetLoader(elementsAccesory).then(async (res) => {
            await this.removeData(line, sections).then(async (res) => {
              let elementAccesory = document.querySelector(
                `[data-accessory=${accessory}]`
              );
              elementAccesory &&
                (await this.removeData(
                  elementAccesory.dataset.set,
                  elementAccesory.dataset.sectionId
                ));
            });
          }));
      } else {
        await this.removeData(line, sections).then((res) => {
          this._disableLoading();
        });
      }
    } catch (er) {
      console.log(er);
    }
  }

  /**
   * Delete product in cart
   * @author Miguel Camcho <miguel.camacho@gradiweb.com>
   */

  async removeData(line, sections) {
    this._enableLoading(line);
    const response = await api.updateCart({
      line: line,
      quantity: 0,
      sections,
    });

    //  Update cart for line
    for (const key in response.sections) {
      if (Object.hasOwnProperty.call(response.sections, key)) {
        $Q(`#shopify-section-${key}`).innerHTML = this.getSectionInnerHTML(
          response.sections[key],
          key
        );
        this._addEvents();
        this.initCountAtHeader();
      }
    }
    return response;
  }

  /**
   * Get how many products there are in the cart
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  async readCartElements() {
    try {
      return await api.read(`${routes.cart_url}.js`);
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }

  /**
   * Init bubble cart and update
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  async initCountAtHeader() {
    try {
      const { item_count } = await this.readCartElements();
      const bubbleCartStringNode = `
        <span class="bubble-cart" id="js-bubble-cart">
          0
        </span>
      `;

      //Validate if component exist or not (There are items in cart or not) for to create
      if (!$Q('#js-bubble-cart')) {
        this.renderElements.renderTextNodes(
          $Q('#js-cart-button-header'),
          bubbleCartStringNode,
          'beforeend'
        );
      }

      const bubbleCart = $Q('#js-bubble-cart');
      // If the component exist (There are items in the cart) update text content
      if (bubbleCart) {
        if (item_count) {
          bubbleCart.textContent = item_count;
        } else {
          bubbleCart.remove();
        }
      }
    } catch (error) {
      console.error(`Error ${error}`);
    }
  }

  /**
   * Listener click in the modal and observer body if notify container was rendering
   * @param {Object} config - Objecto to config function
   * @param {Node} config.btn - Button of bundle modal to listener click
   * @param {Node} config.itemNotify - Container of the notifies
   * @param {Node} config.target - Element to observe
   * @param {String} config.typeAttr - Type attribute to validate ('id', 'class')
   * @param {String} config.elementoToWillSearch - Class or id for search elements rendered
   * @author Daniel Santos <daniel.santos@gmail.com>
   */
  observerNotfyModalBundle({
    btn,
    itemNotify,
    target,
    typeAttr,
    elementoToWillSearch,
  }) {
    const config = {
      childList: true,
    };

    btn.addEventListener('click', (e) => {
      if (itemNotify === 'tdf_quickview') {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              [...mutation.addedNodes].forEach((item) => {
                if (item.getAttribute(typeAttr) === elementoToWillSearch) {
                  if (
                    $Q('.tdf_notify_content')
                      .textContent.trim()
                      .toLocaleLowerCase() === 'added successfully'
                  ) {
                    this.initCountAtHeader();
                  }
                }
              });
            }
          });
        });

        observer.observe(target, config);
      }
    });
  }

  /**
   * Observe body if modal bundle container was rendering
   * @author Daniel Santos <daniel.santos@gmail.com>
   */
  observeBundle() {
    const body = $Q('.body');
    const config = {
      childList: true,
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          [...mutation.addedNodes].forEach((item) => {
            if (item.getAttribute('id') === 'tdf_quickview') {
              const button = $Q('button[data-e="qv_add_to_cart"]', item);

              if ($Q('#tdf_notifies')) {
                this.observerNotfyModalBundle({
                  btn: button,
                  itemNotify: item.getAttribute('id'),
                  target: $Q('#tdf_notifies'),
                  typeAttr: 'class',
                  elementoToWillSearch: 'tdf_notify',
                });
              } else {
                this.observerNotfyModalBundle({
                  btn: button,
                  itemNotify: item.getAttribute('id'),
                  target: body,
                  typeAttr: 'id',
                  elementoToWillSearch: 'tdf_notifies',
                });
              }
            }
          });
        }
      });
    });

    observer.observe(body, config);
  }
}

export { Cart };

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  if (!window.location.pathname.includes('/cart')) {
    const cartContainer = $Q('.cart.sidecart');

    if (cartContainer) {
      cartContainer.setAttribute('data-active', 'false');

      if ($Q('.cart-empty')) {
        toggleDataActive('.js-cart-close-init', '#shopify-section-side-cart', {
          overlay: true,
        });
      }

      toggleDataActive('.js-button-cart', '#shopify-section-side-cart', {
        overlay: true,
      });
    }
  }
};
